import { render, staticRenderFns } from "./RangeOfficerUnitStandards.vue?vue&type=template&id=120dc475&"
import script from "./RangeOfficerUnitStandards.vue?vue&type=script&lang=ts&"
export * from "./RangeOfficerUnitStandards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports